import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

import HistoryView from './HistoryView'
import * as TimeseriesActionCreators from '../../actions/timeseries'
import * as EventActionCreators from '../../actions/event'

class TimeseriesHistoryContainer extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    timeseriesId: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    timeseries: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
    events: PropTypes.object.isRequired,
    eventActions: PropTypes.object.isRequired,
  }

  static styles = () => ({
    centered: {
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  })

  static mapStateToProps(state) {
    return {
      timeseries: state.timeseries,
      events: state.events,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      eventActions: bindActionCreators(EventActionCreators, dispatch),
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.fetchData()
  }

  componentDidUpdate(prevProps) {
    if (this.props.timeseriesId !== prevProps.timeseriesId
      || this.props.limit !== prevProps.limit) {
      this.fetchData()
    }
  }

  fetchData = () => {
    const {
      timeseriesId,
      limit,
      timeseriesActions,
      eventActions,
    } = this.props

    timeseriesActions.fetchTimeseries(timeseriesId)
    eventActions.listSparseEvents(timeseriesId, limit)
  }

  timeseries(timeseries = this.props.timeseries) {
    return timeseries[this.props.timeseriesId]
  }

  events() {
    return this.props.events[this.props.timeseriesId] || []
  }

  render() {
    const events = this.events()
    if (events.length > 0) {
      return <HistoryView events={events} timeseries={this.timeseries()} />
    }
    return (
      <div className={this.props.classes.centered}>
        <Typography variant="h2">Data Not Available</Typography>
      </div>
    )
  }
}

export default connect(
  TimeseriesHistoryContainer.mapStateToProps,
  TimeseriesHistoryContainer.mapDispatchToProps,
)(withStyles(TimeseriesHistoryContainer.styles)(TimeseriesHistoryContainer))
